import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import {
  app
} from './config'
import moment from 'moment-timezone'

import VueAgile from 'vue-agile'
import Vuesax from 'vuesax'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import VueZoomer from 'vue-zoomer'
import CKEditor from '@ckeditor/ckeditor5-vue'
import Vuetify from 'vuetify'
import InstantSearch from 'vue-instantsearch'
const HelloJs = require('hellojs/dist/hello.all.min.js')
const VueHello = require('vue-hellojs')
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

Vue.config.productionTip = false

HelloJs.init({
  google: '672047692198-t9pcavh0e6rapp6ir380sskn696nmqh9.apps.googleusercontent.com'
}, {
  redirect_uri: 'authcallback/'
})

Vue.use(VueHello, HelloJs)
Vue.use(VueAgile)
Vue.use(Vuesax)
Vue.use(PerfectScrollbar)
Vue.use(VueZoomer)
Vue.use(CKEditor)
Vue.use(Vuetify)
Vue.use(InstantSearch)
Vue.use(VueSweetalert2);

const Pusher = require('pusher-js')
var pusher = new Pusher('bf53ac986f4812ea8785', {
  cluster: 'eu'
})

moment.tz.setDefault('Asia/Dubai')
const token = localStorage.getItem('token')
const base = axios.create({
  baseURL: process.env.VUE_APP_API_CORE
})

base.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  return config
})

const baseSearch = axios.create({
  baseURL: process.env.VUE_APP_SEARCH_CORE
})

baseSearch.interceptors.request.use(config => {
  config.headers.Authorization = `Bearer IZG9U3nkl3U1lWWQ5Sq0`
  return config
})

Vue.prototype.moment = moment
Vue.prototype.$http = base
Vue.prototype.$httpSearch = baseSearch
Vue.prototype.$pusher = pusher

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// make sure the surge.sh page go to https
if (window.location.href.indexOf('http://localhost') == -1 && window.location.href.indexOf('http://') > -1) { window.location.href = window.location.href.replace('http://', 'https://') }
